import { useEffect } from 'react';
import { useState } from 'react';
import PricingMonthlyCard from './PricingMonthlyCard';
import { useDispatch } from 'react-redux';
import { getProductPricing , getBookingProduct , getProductById} from '../../../redux/actions/pricing';
import { useSelector } from 'react-redux';
import ProductMonthlyModal from './ProductMonthlyModal';
import ProductAnnualModal from '../PricingAnnual/ProductAnnualModal';
import PricingFooter from '../PricingFooter';
import PricingNavbar from '../PricingNavbar';
const PricingMonthly = ({ product_type, subscription_type, razorpayHandler,route }) => {
  const [activePricingId, setActivePricingId] = useState(3);
  const [cardDatas, setCardDatas] = useState([]);
  const [cardAnnualDatas,setCardAnnualDatas] = useState([]);
  const dispatch = useDispatch();
  const userSubscription = useSelector(store => store?.userSubscription)
  const [seeDetails, setSeeDetails] = useState(false);
  const authentication = useSelector(store=> store?.authentication)
  const [proPlusData , setProPlusData] = useState([]);
  const [bookingProduct, setBookingProduct] = useState({ cost: 0 });
  // const authentication = useSelector(store=> store?.authentication)

  useEffect(() => {

    dispatch(getProductPricing(product_type, subscription_type, (successObj) => {
      setCardDatas(successObj);
    }))
    dispatch(getBookingProduct((successObj) => {
      setBookingProduct(successObj);
  }))

    dispatch(getProductPricing(product_type, 'annual', (successObj) => {
      setCardAnnualDatas(successObj);
  }))

  }, [])
  useEffect(()=>{
    if(userSubscription?.user_role === 3){
    dispatch(getProductById(2 , (successObj)=> {
      setProPlusData(successObj);
    } , (err)=>{}))
}
  },[userSubscription?.user_role])

  const plan = () => {
    if (userSubscription?.role_type === "pro")
        return "LearnTube Pro Plan.";
    else if (userSubscription?.role_type === "pro_plus")
        return "LearnTube Pro+ Plan.";
    else if(userSubscription?.role_type === 'x')
        return "LearnTubeX Plan."
    else if(userSubscription?.role_type === 'max')
       return "LearnTube Max Plan."
    else
        return "LearnTube Max Trial Plan."
}
  return (
    <div className="fixed z-10 top-0 left-0 w-full h-full overflow-y-scroll bg-blue-50 flex flex-col items-center">
      <PricingNavbar route={route}/>
      <div className="mt-2 object-fill flex flex-col justify-center items-center">
        <h1 className="lg:text-4xl md:text-3xl md:mb-2 font-bold items-center text-center">Upgrade your Career with Certification, Live</h1>
        <h1 className=" lg:text-4xl  md:text-3xl   font-bold font-bold text-center text-center " >Sessions & Placement Support</h1>
      </div>
      {
             authentication!== null &&
             <>{userSubscription?.user_role ===1 ? <div className='rounded-lg bg-orange-200 mt-5 pr-4 pl-4 h-8 flex justify-center items-center text-xs xl:text-sm text-orange-900 '>You're subscribed to a free plan.  
             <a className='underline text-cyan-600 cursor-pointer whitespace-nowrap' onClick={(event)=> setSeeDetails(!seeDetails)}>{" "}See details</a>
         </div> : <div className='rounded-lg bg-orange-200 mt-5 pr-4 pl-4 h-8 flex justify-center items-center text-xs xl:text-sm text-orange-900 '>You're subscribed to {plan()} 
             <a className='underline text-cyan-600 cursor-pointer whitespace-nowrap' onClick={(event)=> setSeeDetails(!seeDetails)}>{" "}See details</a>
         </div> 
         }</> 
            
        }
      {seeDetails && < ProductAnnualModal cardDatas={cardAnnualDatas} cardMonthlyDatas={cardDatas} userPlan={userSubscription} isModalEnabled={seeDetails} setIsModalEnabled={setSeeDetails} proPlusData={proPlusData} bookingProduct={bookingProduct}/>}
      <div className="w-10/12 md:w-11/12 xl:w-8/12 mt-7  md:mt-10  flex flex-col md:flex-row justify-center items-center mb-8">
        {
          cardDatas.map((cardData) => <PricingMonthlyCard razorpayHandler={razorpayHandler} id={cardData?.sort_order} cardData={cardData} details={cardData?.pp_product_pointers} isCardEnabled={activePricingId === cardData?.sort_order} setIsCardEnabled={setActivePricingId} userPlan={userSubscription} isModalEnabled={seeDetails} setIsModalEnabled={setSeeDetails} cardDatas={cardDatas}></PricingMonthlyCard>)
        }
      </div>
      <PricingFooter/>
    </div>
  )
}

export default PricingMonthly;
